import { IconButton, Tooltip } from '@mui/material';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import { useTranslation } from 'react-i18next';

interface Props {
  googleChatLink: string;
}

export default function ContactUs({ googleChatLink }: Props) {
  const { t } = useTranslation('global');
  return googleChatLink ? (
    <Tooltip placement="bottom" title={t('general.contactUs')}>
      <IconButton
        onClick={() =>
          window.open(googleChatLink, '_blank', 'noopener noreferrer')
        }
        style={{ color: '#0E335C' }}
      >
        <ContactSupportIcon />
      </IconButton>
    </Tooltip>
  ) : (
    <IconButton disabled>
      <ContactSupportIcon />
    </IconButton>
  );
}
